module.exports = __webpack_public_path__ + "static/media/slide-5.439484bd.jpg";